import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { pxToRem } from '../../../utils/pxToRem';
import { conventionContent } from '../content';
import { RegisterButton } from '../components/RegisterButton';

export function Hero() {
  const { hero } = conventionContent;

  return (
    <Box
      component="header"
      id={hero.sectionId}
      sx={{
        position: 'relative',
        width: '100%',
        backgroundColor: 'primary.main',
        height: { mobile: pxToRem(210), laptop: pxToRem(450) },
        overflow: 'hidden',
      }}
    >
      <Stack
        sx={{
          position: 'absolute',
          inset: 0,
          alignItems: 'center',
          justifyContent: 'center',
          gap: { mobile: pxToRem(10), laptop: pxToRem(21) },
        }}
      >
        <Box
          component="img"
          src={hero.logoSrc}
          alt={hero.logoAlt}
          sx={{
            display: 'block',
            width: { mobile: pxToRem(225), laptop: pxToRem(350) },
            height: { mobile: pxToRem(116), laptop: pxToRem(180) },
            objectFit: 'contain',
          }}
        />
        <RegisterButton
          tone="onDark"
          label={hero.registerCta.label}
          href={hero.registerCta.href}
          ariaLabel={hero.registerCta.ariaLabel}
          sx={{ width: { mobile: pxToRem(224), laptop: pxToRem(350) } }}
        />
      </Stack>
    </Box>
  );
}
